import React from "react";
import { Box, Paper, Stack, Container } from "@mui/material";
import HelpOutlinedIcon from "@mui/icons-material/HelpOutlined";
import { Skeleton } from "@mui/material";

export const CardSkeleton: React.FC = () => {
  return (
    <Box
      style={{
        height: "200px",
        display: "flex",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Paper sx={{ width: "100%", backgroundColor: "#D1D3D5" }}>
        <Stack
          direction="row"
          sx={{
            mx: "10px",
          }}
        >
          <Container
            sx={{ position: "relative", height: "100px", width: "50%" }}
          >
            <Paper
              elevation={3}
              sx={{
                padding: "30px",
                backgroundColor: `#D1D3D5`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "absolute",
                top: "-40px",
              }}
            >
              <HelpOutlinedIcon fontSize="large" sx={{ color: "white" }} />
            </Paper>
          </Container>

          <Stack
            spacing={2}
            sx={{
              width: "100%",
              display: "flex",
              my: "20px",
            }}
          >
            <Skeleton />
            <Skeleton />
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
              }}
            ></Box>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
};
